
import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./RowFieldWithButtonsContainer.module.scss";

interface RowFieldWithButtonsContainer {
  /** Массив полей (ReactNode), будут рендериться слева */
  fields: ReactNode[];
  /** Массив кнопок/действий (ReactNode), будут рендериться справа */
  buttons?: ReactNode[];
  /** Дополнительный класс для контейнера */
  className?: string;
  /** Gap между элементами (px) */
  gap?: number;
}

export const RowFieldWithButtonsContainer: React.FC<RowFieldWithButtonsContainer> = ({
  fields,
  buttons,
  className,
  gap = 8,
}) => {
  return (
    <div
      className={cn(styles.container, className)}
      style={{ gap: `${gap}px` }}
    >
      <div className={styles.fields}>
        {fields.map((field, i) => (
          <div key={i} className={styles.fieldWrapper}>
            {field}
          </div>
        ))}
      </div>

      {buttons && buttons.length > 0 && (
        <div className={styles.buttons}>
          {buttons.map((button, i) => (
            <div key={i} className={styles.buttonWrapper}>
              {button}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
